import { setStoredString, useStoredString } from "../../../shared/storage/storedString";

/**
 * How the Documents screen writes documents' keys (F136; v1's "Kurz-ID Format"): in full, as
 * imported, or in the short form its corpus declares (`3/134` for `10300134`). One choice for
 * every corpus, kept in this browser, followed at once by every view; in full at first, as v1
 * had it.
 */
export type KeyForm = "full" | "short";

const KEY_FORM_STORAGE_KEY = "dmw.documentKeyForm";

export function useKeyForm(): KeyForm {
  return useStoredString(KEY_FORM_STORAGE_KEY) === "short" ? "short" : "full";
}

export function setKeyForm(form: KeyForm): void {
  setStoredString(KEY_FORM_STORAGE_KEY, form);
}

/** A document's key in `form`: its short form where its corpus writes one, else in full. */
export function shownKey(document: { readonly key: string; readonly shortKey: string | null }, form: KeyForm): string {
  return form === "short" && document.shortKey !== null ? document.shortKey : document.key;
}
